import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { DelayCategory } from "../models/CatalogCategory";

type getCatalogCategoriesProps = {
	includeInactives: boolean;
	delayAreaAssetId?: number | null;
	includeAncestor?: boolean;
};

export const getCatalogCategories = async ({
	includeInactives,
	delayAreaAssetId,
	includeAncestor,
}: getCatalogCategoriesProps) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "IncludeInactive", value: includeInactives },
	];

	if (delayAreaAssetId)
		parameters.push({ name: "DelayAreaAssetId", value: delayAreaAssetId });
	if (includeAncestor)
		parameters.push({ name: "IncludeAncestor", value: includeAncestor });

	const resp = await apiService.callV2(
		"[DEL].[GetDelayCategories]",
		parameters,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as DelayCategory[];
	} else {
		throw new Error(resp.message || "Error fetching categories");
	}
};

export const deleteCatalogCategory = async (delayCategoryId: number | null) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "DelayCategoryId", value: delayCategoryId },
	];

	const resp = await apiService.callV2(
		"[DEL].[DeleteDelayCategory]",
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error deleting category");
	}
};

export const upsertCatalogCategory = async (category: DelayCategory) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "DelayCategoryId", value: category.DelayCategoryId },
		{
			name: "DelayCategoryName",
			value: category.DelayCategoryName,
		},
		{ name: "DelayCategoryColor", value: category.DelayCategoryColor },
		{ name: "IsActive", value: category.IsActive },
		{ name: "Description", value: category.Description },
	];

	const resp = await apiService.callV2(
		"[DEL].[UpsertDelayCategory]",
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error upserting category");
	}
};
